export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0/static/dummy-4754033108e15cd75e02fe810b783714.svg";